import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ReportStatus, SalesReportViewType } from 'src/app/enum';
import {
  ILocationSimple,
  ISalesReportDto,
  ISalesReportSearchData
} from 'src/app/_services/reports.service';

@Component({
  selector: 'sales-report-card',
  templateUrl: './sales-report.card.html',
  host: { class: 'sales-report-card' },
  styleUrls: ['./sales-report.card.scss']
})
export class SalesReportCard implements OnInit, OnDestroy {
  @Input() public search: Observable<ISalesReportSearchData>;
  @Input() public isLoading = false;
  @Input() public isReady = false;
  @Input() public canManage = false;
  @Output() public expand = new EventEmitter<void>();

  public report: ISalesReportDto | null;
  public expiresAt: Date | null = null;
  public selectedLocations: ILocationSimple[] = [];
  public selectedProductLabel: string | null = null;
  public viewType: SalesReportViewType = SalesReportViewType.ProductByDay;
  public dateFrom: Date | null = null;
  public dateTo: Date | null = null;

  private _searchSub: Subscription;

  constructor(private _route: ActivatedRoute) {
    this.report = (this._route.snapshot.data.report as ISalesReportDto) || null;
    this.expiresAt = this.report?.expiresAt || null;
  }

  public get isExpired(): boolean {
    return this.report?.status === ReportStatus.Expired;
  }

  public get retailerName(): string {
    return this.report?.provider?.name ?? '';
  }

  public get isLocationView(): boolean {
    return this.viewType === SalesReportViewType.LocationByDay;
  }

  public get selectionLabelKey(): string {
    return this.isLocationView
      ? 'cards.reports.sales_report.selected_product'
      : 'cards.reports.sales_report.selected_stores';
  }

  public get emptySelectionKey(): string {
    return this.isLocationView
      ? 'cards.reports.sales_report.all_products'
      : 'cards.reports.sales_report_search.stores_placeholder';
  }

  public get selectionItems(): string[] {
    if (this.isLocationView) {
      return this.selectedProductLabel ? [this.selectedProductLabel] : [];
    }

    return (this.selectedLocations || []).map((x) => x.name).filter(Boolean);
  }

  public ngOnInit() {
    if (this.search) {
      this._searchSub = this.search.subscribe((data) => {
        if (!data) {
          return;
        }

        this.viewType = data.viewType || SalesReportViewType.ProductByDay;
        this.selectedLocations = data.locations || [];
        this.selectedProductLabel = data.productLabel || null;
        this.dateFrom = (data.from as Date) || null;
        this.dateTo = (data.to as Date) || null;
      });
    }
  }

  public ngOnDestroy() {
    this._searchSub?.unsubscribe();
  }
}
